'use client';

import type { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useFaqExpandState } from '@/components/blocks/cms/Faq/FaqExpandProvider';

export interface FaqExpandProps {
    children: ReactNode;
    itemIndex: number;
}

const collapsed = { height: 0, opacity: 0 };
const uncollapsed = { height: 'auto', opacity: 1 };

export function FaqExpand({ children, itemIndex }: FaqExpandProps) {
    const { countLimit } = useFaqExpandState();
    const isUnderLimit = itemIndex < countLimit;

    return (
        <motion.article
            className="collapse collapse-arrow join-item border-t-base-300 border-t first:border-t-0 rounded-none"
            initial={isUnderLimit ? false : collapsed}
            animate={isUnderLimit ? uncollapsed : collapsed}
            exit={collapsed}
        >
            {children}
        </motion.article>
    );
}
